import * as React from 'react';

const PersonMehSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 21c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-19C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M7 14.5h10v1H7z"
        />
        <g fillRule="evenodd" clipRule="evenodd" fill="#231F20">
            <path d="M8 8h1v2H8zM15 8h1v2h-1z" />
        </g>
    </svg>
);

PersonMehSvg.displayName = 'PersonMehSvg';
export default PersonMehSvg;
